<i18n src="./resources/locales.json"></i18n>
<template>
  <v-dialog :value="display" max-width="75%" persistent>
    <v-card class="surface">
      <v-card-title class="surface">
        <v-tabs v-model="tab" class="surface">
          <v-tab v-once>
            {{ $t('hideColumns') }}
          </v-tab>
          <v-tab v-once>
            {{ $t('reorderColumns') }}
          </v-tab>
          <v-tab v-once>
            {{ $t('displayBusinessProcesses') }}
          </v-tab>
        </v-tabs>
      </v-card-title>

      <v-card-text class="surface">
        <v-tabs-items v-model="tab" class="surface">
          <v-tab-item class="tab-content">
            <v-checkbox
              v-for="column in hiddenColumnItems"
              :key="column.value"
              :input-value="column.hide"
              :label="$t(`columns.${column.value}`)"
              hide-details
              @change="value => onColumnSelection(value, column.value)"
            ></v-checkbox>
          </v-tab-item>
          <v-tab-item class="tab-content">
            <EcsHeaderReorder :headers="tempItems" :tab="tab" @onColumnReorder="onColumnReorder" />
          </v-tab-item>
          <v-tab-item class="tab-content">
            <v-checkbox
              v-for="bp in bpItems"
              :key="bp.businessProcessId"
              :input-value="bp.isDisplayed"
              :label="bp.businessProcessName"
              hide-details
              @change="value => onBpSelection(value, bp.businessProcessId)"
            ></v-checkbox>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialogClose">
          <span v-once>{{ $t('cancel') }}</span>
        </v-btn>
        <v-btn color="primary" depressed @click="() => dialogAccept(tempItems, tempHiddenBusinessProcessesIds)">
          <span v-once>{{ $t('save') }}</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import EcsHeaderReorder from '@/components/ecs-business-process-summary-table/EcsHeaderReorder';

export default {
  name: 'EcsHideColumns',

  components: { EcsHeaderReorder },

  props: {
    display: {
      type: Boolean,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    dialogClose: {
      type: Function,
      required: true
    },
    dialogAccept: {
      type: Function,
      required: true
    },
    businessProcesses: {
      type: Array,
      required: true
    },
    hiddenBusinessProcessesIds: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  data() {
    return {
      tempItems: [],
      tab: 0,
      windowsGrid: null,
      tempHiddenBusinessProcessesIds: []
    };
  },

  computed: {
    bpItems() {
      return this.businessProcesses.map(({ businessProcessId, businessProcessName }) => {
        return {
          businessProcessId,
          businessProcessName,
          isDisplayed: !this.tempHiddenBusinessProcessesIds.includes(businessProcessId)
        };
      });
    },
    hiddenColumnItems() {
      return this.tempItems.filter(tempItem => tempItem.value !== 'businessProcessName');
    }
  },

  watch: {
    display(newValue) {
      if (newValue) {
        this.tempItems = structuredClone(this.items);
        this.tempHiddenBusinessProcessesIds = structuredClone(this.hiddenBusinessProcessesIds);
        this.tempItems.sort((a, b) => a.columnIndex - b.columnIndex);
      }
    }
  },

  methods: {
    onColumnSelection(newValue, headerValue) {
      const headerIndex = this.tempItems.findIndex(i => i.value === headerValue);
      this.tempItems[headerIndex].hide = newValue;
    },

    onColumnReorder(newOrder) {
      newOrder.forEach((item, index) => {
        const headerIndex = this.tempItems.findIndex(header => header.value === item);
        this.tempItems[headerIndex].columnIndex = index;
        this.tempItems.sort((a, b) => a.columnIndex - b.columnIndex);
      });
    },

    onBpSelection(checked, bpId) {
      if (checked) {
        this.tempHiddenBusinessProcessesIds = this.tempHiddenBusinessProcessesIds.filter(
          currentBpId => bpId !== currentBpId
        );
      } else {
        this.tempHiddenBusinessProcessesIds.push(bpId);
      }
    }
  }
};
</script>

<style scoped>
.tab-content {
  height: 400px;
  overflow-y: auto;
  padding-left: 20px;
}

::v-deep .v-slide-group__content.v-tabs-bar__content {
  background-color: var(--v-surface-base) !important;
  border-color: var(--v-surface-base) !important;
}
</style>
